import React, { useState } from 'react';

const CharacterFlipCard = ({ character }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="group flip-card cursor-pointer transition-transform duration-300 hover:-translate-y-1 focus:outline-none"
      onClick={() => setFlipped(!flipped)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setFlipped(!flipped);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Flip card for ${character.name}`}
      style={{
        width: '300px',
        height: '500px',
        perspective: '1200px',
      }}
    >
      <div
        className={`flip-card-inner relative w-full h-full text-center transition-transform duration-700 ${flipped ? 'rotate-y-180' : ''}`}
        style={{
          transformStyle: 'preserve-3d',
        }}
      >
        {/* Front of card */}
        <div
          className="flip-card-front absolute w-full h-full rounded-xl overflow-hidden shadow-2xl border border-amber-200/35 bg-stone-950 transition-all duration-500 group-hover:border-amber-300/70 group-hover:shadow-orange-950/70"
          style={{
            backfaceVisibility: 'hidden',
          }}
        >
          <img
            src={character.image}
            alt={character.name}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_50%_80%,rgba(251,146,60,0.22),transparent_45%)]" />

          <div className="absolute left-0 right-0 bottom-0 p-5">
            <div className="mx-auto mb-3 h-px w-16 bg-amber-300/60" />
            <h3 className="text-lg font-bold text-amber-50 leading-tight drop-shadow">
              {character.name}
            </h3>
            <p className="mt-2 text-[11px] uppercase tracking-[0.22em] text-amber-200/80">
              Tap to reveal
            </p>
          </div>
        </div>

        {/* Back of card */}
        <div
          className="flip-card-back absolute w-full h-full rounded-xl overflow-hidden shadow-2xl border border-amber-200/35 bg-stone-950 flex flex-col justify-center p-5"
          style={{
            backfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-stone-950 via-stone-900 to-black" />
          <div className="absolute inset-0 opacity-35 bg-[radial-gradient(circle_at_20%_10%,rgba(251,191,36,0.28),transparent_35%),radial-gradient(circle_at_90%_80%,rgba(194,65,12,0.28),transparent_40%)]" />
          <div className="absolute inset-0 opacity-20 bg-[linear-gradient(120deg,transparent,rgba(255,255,255,0.08),transparent)]" />

          <div className="relative z-10 space-y-4">
            <div>
              <div className="mx-auto mb-4 h-px w-16 bg-amber-300/60" />
              <h3 className="text-base font-bold text-amber-50 leading-tight">
                {character.name}
              </h3>
            </div>

            <p className="text-sm text-stone-200 leading-relaxed">
              {character.backstory}
            </p>

            <div className="rounded-lg border border-amber-200/20 bg-black/25 px-3 py-3">
              <p className="text-xs text-amber-100/85 italic leading-relaxed">
                {character.symbols}
              </p>
            </div>

            <a
              href={character.spotify}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-amber-200 text-stone-950 px-4 py-2 rounded-md text-sm font-bold hover:bg-amber-100 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
              onClick={(e) => e.stopPropagation()}
            >
              🎧 Listen
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharacterFlipCard;
